/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { KambiBetOffer } from '@mobi/api-types/kambi'
import { KambiSpecialHelper } from '@mobi/sports-offering/context'
import type { AppSeoSportsData, SportsFavouriteTrackingData } from './types'

/** Private registry of host helpers, w/ default empty functions */
let _HostHelpers = {
  trackEvent(eventObj: SportsFavouriteTrackingData) {},

  triggerHapticFeedback(type: 'success' | 'impact-light') {},

  useAppSeoForSports: (data: AppSeoSportsData) => {},

  logToSentry(message: string | Error, additionalProperties: Record<string, unknown>) {},

  handleAddToKambiBetSlipClick(
    arg: { outcomeIds: KambiBetOffer['outcomes'][0]['id'][] } | { prePacksIds: number[] }
  ): void {},

  handlePropositionClick(outcome: KambiBetOffer['outcomes'][0]['id'], isSelected: boolean): void {},

  useKambiSpecials: (isLoggedIn: boolean): KambiSpecialHelper => ({
    hasSpecial: () => false,
    sgmSpecials: () => ({ hasSGM: false, specials: undefined }),
    getSpecials: () => [],
    isLoading: false,
  }),
}

// ============================================
// Individual Exports for use in Client Package
// ============================================

export const trackEvent: typeof _HostHelpers.trackEvent = data => {
  _HostHelpers.trackEvent(data)
}

export const triggerHapticFeedback: typeof _HostHelpers.triggerHapticFeedback = data => {
  _HostHelpers.triggerHapticFeedback(data)
}

export const useAppSeoForSports = (data: AppSeoSportsData) => {
  return _HostHelpers.useAppSeoForSports(data)
}

export const logToSentry: typeof _HostHelpers.logToSentry = (data, props) =>
  _HostHelpers.logToSentry(data, props)

export const handleAddToKambiBetSlipClick: typeof _HostHelpers.handleAddToKambiBetSlipClick =
  arg => {
    _HostHelpers.handleAddToKambiBetSlipClick(arg)
  }

export const handlePropositionClick: typeof _HostHelpers.handlePropositionClick = (
  outcome,
  isSelected
) => {
  _HostHelpers.handlePropositionClick(outcome, isSelected)
}

export const useKambiSpecials: typeof _HostHelpers.useKambiSpecials = isLoggedIn => {
  return _HostHelpers.useKambiSpecials(isLoggedIn)
}

// ================
// Main Host Setter
// ================

/** Set host functions in module scope (NOT inside react)
 *  ONLY to be used in Host
 */
export function initHostHelpers(initHelpers: Partial<typeof _HostHelpers>) {
  _HostHelpers = Object.assign(_HostHelpers, initHelpers)
}
